/**
 * @generated SignedSource<<757dc41a7ceeb1cd0ca5f8721ef70802>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type CodeScanningSecurityAlertStatus = "DISMISSED" | "FIXED" | "OPEN" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type LinkedSecurityAlertsFragment$data = {
  readonly repository: {
    readonly nameWithOwner: string;
  };
  readonly securityAlerts: {
    readonly nodes: ReadonlyArray<{
      readonly number: number | null | undefined;
      readonly repository: {
        readonly nameWithOwner: string;
      } | null | undefined;
      readonly status: CodeScanningSecurityAlertStatus | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"LinkedSecurityAlert" | "LinkedSecurityAlertIcon" | "LinkedSecurityAlertLinkItem">;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "LinkedSecurityAlertsFragment";
};
export type LinkedSecurityAlertsFragment$key = {
  readonly " $data"?: LinkedSecurityAlertsFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"LinkedSecurityAlertsFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "concreteType": "Repository",
  "kind": "LinkedField",
  "name": "repository",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "nameWithOwner",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LinkedSecurityAlertsFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "CodeScanningSecurityAlertConnection",
      "kind": "LinkedField",
      "name": "securityAlerts",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CodeScanningSecurityAlert",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "number",
              "storageKey": null
            },
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "status",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "LinkedSecurityAlert"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "LinkedSecurityAlertIcon"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "LinkedSecurityAlertLinkItem"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Issue",
  "abstractKey": null
};
})();

(node as any).hash = "bb320e456d319200b83aa6e6558131ec";

export default node;
